import React from 'react';
import CapacityPlantTemplate from '../../components/CapacityPlantTemplate';
import { capacityPlants } from '../../data/capacityPlants';

const WaterPlant20BPM = () => (
  <CapacityPlantTemplate plant={capacityPlants['/20-bpm-water-plant']} path="/20-bpm-water-plant" />
);

export default WaterPlant20BPM;
